module.exports = __webpack_public_path__ + "static/img/map2.4808a8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/traffic/map2.jpg
// module id = oC27
// module chunks = 3